import { render } from "./LogsPage.vue?vue&type=template&id=6639084c&scoped=true"
import script from "./LogsPage.vue?vue&type=script&lang=js"
export * from "./LogsPage.vue?vue&type=script&lang=js"

import "./LogsPage.vue?vue&type=style&index=0&id=6639084c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6639084c"]])

export default __exports__